import ApplicationStateDana from "@dana/Store/DanaApplicationState";

import { OrderInfo } from "@dana/Services/StandardReturnDetailsService";
import { StandardReturnHistotyStateActions } from "@dana/Store/Data/StandardReturnsStatus/Reducers/StandardReturnsStatusReducer";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import translate from "@insite/client-framework/Translate";
import { DispatchProp } from "react-redux";

type HandlerType = Handler<{}, DispatchProp<StandardReturnHistotyStateActions>>;

export const DispatchBeginExportCredits: HandlerType = props => {
    props.dispatch({
        type: "StandardReturnsHistory/IsLoading",
        isLoading: true,
    });
};

export const ExportData: HandlerType = async props => {
    const { unparse } = await import(/* webpackChunkName: "papaparse" */ "papaparse");

    let data: any[] = [];
    const state = props.getState();
    const language = state.context.session.language;
    const danaState = props.getState() as ApplicationStateDana;
    const orderLines: any = danaState.standardReturnsDetailsState?.orderModel?.orderInfo;
    if (orderLines.length) {

        const primaryPo = translate("Primary PO Number");
        const partNumber = translate("Part Number");
        const description = translate("Description");
        const quantityOrdered = translate("Qty Ordered");
        const unitPrice = translate("Unit Price (USD)");
        const tarrifPrice = translate("Unit Tariff Fee (USD)");
        const codeDeposit = translate("Unit Core Deposit (USD)");
        const extendePrice = translate("Extended Price (USD)");
        const weightLb = translate("Weight (LB)");

        let totalQuantity = 0;
        let totalUnitAmount = 0;
        let totalExtendedAmount = 0;
        let totalWeight = 0;

        const rows = orderLines?.map((orderInfo: OrderInfo) => {
            if (!orderInfo) {
                return null;
            }

            totalQuantity = totalQuantity + orderInfo.quantityOrdered;
            totalUnitAmount = totalUnitAmount + orderInfo.pricePerUnit;
            totalExtendedAmount = totalExtendedAmount + (orderInfo.netAmount + orderInfo.extendedAmount );
            totalWeight = totalWeight + orderInfo.weight;

            return {
                [primaryPo]: danaState.standardReturnsDetailsState?.orderModel?.poNumber,
                [partNumber]: orderInfo.partNumber ?? "",
                [description]: orderInfo.partDescription ?? "",
                [quantityOrdered]: orderInfo.quantityOrdered ?? 0,
                [unitPrice]: orderInfo.pricePerUnit ?? "",
                [tarrifPrice]: orderInfo.tariff ?? "",
                [codeDeposit]: orderInfo.extendedAmount.toFixed(2) ?? "",
                [extendePrice]: (orderInfo.netAmount + orderInfo.extendedAmount).toFixed(2) ?? "",
                [weightLb]: orderInfo.weight.toFixed(2) ?? "",
            };
        }) ?? [];

        for (const row of rows) {
            data.push(row);
        }
        const totalRow = {
            [primaryPo]: "",
            [partNumber]: "",
            [description]: "Total",
            [quantityOrdered]: totalQuantity,
            [unitPrice]: totalUnitAmount.toFixed(2),
            [tarrifPrice]: "",
            [codeDeposit]: "",
            [extendePrice]: totalExtendedAmount.toFixed(2),
            [weightLb]: totalWeight.toFixed(2),
        };
        data.push(totalRow);

        const csv = unparse(data);
        const csvBlob = new Blob([`\uFEFF${csv}`], { type: "text/csv;charset=utf-8;" });

        const fileName = `order_${danaState.standardReturnsDetailsState?.orderModel?.documentNumber}.csv`;
        const downloadLink = document.createElement("a");
        downloadLink.href = window.URL.createObjectURL(csvBlob);
        downloadLink.setAttribute("download", fileName);
        downloadLink.click();
    }

};

export const DispatchCompleteExportCredits: HandlerType = props => {
    props.dispatch({
        type: "StandardReturnsHistory/IsLoading",
        isLoading: false,
    });
};

export const chain = [DispatchBeginExportCredits, ExportData, DispatchCompleteExportCredits];

const exportStandardReturnOrder = createHandlerChainRunner(chain, "ExportStandardReturn");
export default exportStandardReturnOrder;
